import { useEffect, useState } from 'react';
import { notification } from 'antd';
import { Helmet } from 'react-helmet';
import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';

import { useParams, useNavigate } from 'react-router-dom';

import Place from '../../assets/icons/Place';
import LearnSubjectCard from '../../components/LearnSubjectCard/LearnSubjectCard';
//import { getSingleTutor } from "../../services/tutorService";
import Carousel from 'react-multi-carousel';
import { tutors, singleSubject } from '../../dummyData';
import { baseURL } from '../../utils/axios';

const SingleTutor = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [tutor, setTutor] = useState([]);
  const [loading, setLoading] = useState(false);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      paritialVisibilityGutter: 60,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      paritialVisibilityGutter: 60,
    },
  };

  useEffect(() => {
    let token = localStorage.getItem('token');
    const getTutor = async () => {
      setLoading(true);
      const res = await fetch(`${baseURL}/tutors/${id}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      const data = await res.json();

      if (res.status === 200) {
        setTutor(data.data.tutor);
      }
      setLoading(false);
      if (res.status === 401) {
        notification['error']({
          message: 'Session expired, please log in again',
        });
        navigate('/login');
      }
      setLoading(false);
    };

    getTutor();
  }, []);

  let provider = window.location.pathname.includes('tutor')
    ? 'topics'
    : 'subjects';

  return (
    <div>
      <Helmet>
        <title>PL by Edves | Tutor</title>
      </Helmet>{' '}
      {loading ? (
        <p>Please wait</p>
      ) : (
        <>
          <DashboardHeader />
          <div className='single-subject'>
            <div
              className='single-subject__hero'
              style={{
                backgroundImage: `url(${tutors[id - 1]?.banner})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
              }}
            >
              <div className='single-subject__hero__breadcrumbs'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z'
                    fill='white'
                  />
                </svg>
                <p>
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => window.history.back()}
                  >
                    Home{' '}
                  </span>
                  | {tutors[id - 1]?.first_name}
                </p>
              </div>
            </div>
            <div className='single-subject__hero__info'>
              <div className='single-subject__hero__info__logo'>
                <img src={tutors[id - 1]?.avatar} alt='' />
              </div>

              <div className='single-subject__hero__info__details'>
                <h2 style={{ textTransform: 'capitalize' }}>
                  {tutors[id - 1]?.first_name} {tutors[id - 1]?.last_name}
                </h2>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <Place /> <p>{tutors[id - 1]?.location}</p>
                </div>
                <p>{tutors[id - 1]?.summary}</p>
              </div>
            </div>

            <div className='dashboard-body'>
              <div
                className='recommended-section__title'
                style={{ marginBottom: '40px' }}
              >
                <h2 style={{ textTransform: 'capitalize' }}>
                  {provider} offered
                </h2>
                <p>
                  These are {provider} specific to your class being offered by{' '}
                  {tutors[id - 1]?.first_name} {tutors[id - 1]?.last_name}
                </p>
              </div>
              <Carousel
                responsive={responsive}
                showDots={true}
                itemClass={`carouselItem`}
              >
                {tutors[id - 1]?.subjects.length > 0 ? (
                  tutors[id - 1]?.subjects?.map((el, index) => (
                    <LearnSubjectCard
                      index={index}
                      key={el.id}
                      schoolHeader={el.banner}
                      subject={el.name}
                      description={el.description}
                      topic={el.title}
                      duration={el.duration}
                      subjectHeader={el.header}
                      selectSchool={() => {
                        navigate(`/tutor-learn/${el.id}/${id}`);
                      }}
                      page='dashboard'
                    />
                  ))
                ) : (
                  <div>
                    <p>No courses available for this tutor</p>
                  </div>
                )}
              </Carousel>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SingleTutor;
